<template>
  <RevInfoBlock
    :content="i18n(translations.errorContent)"
    :cta="i18n(translations.tryAgain)"
    :icon="IconWarning"
    :title="i18n(translations.errorTitle)"
    variant="danger"
    @click="emit('try-again')"
  />
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevInfoBlock } from '@ds/components/InfoBlock'
import { IconWarning } from '@ds/icons/IconWarning'

import translations from './ErrorInfoBlock.translations'

const i18n = useI18n()
const emit = defineEmits(['try-again'])
</script>
